import { useMutation } from '@tanstack/react-query';
import { GOrganisation } from 'interfaces/IGlobalCatalogue';
import { setActiveGOrganisation } from '../redux/slices/GlobalCatalogueSlice';
import { useDispatch } from 'react-redux';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';
import { toast } from 'utils/toast';
import {
  GC_ORG_BACKEND_ERROR_MESSAGE,
  GC_ORG_FETCH_ERROR_MESSAGE,
} from 'constants/messageConstants';

export const useOrganisationCollectionMutation = () => {
  const dispatch = useDispatch();

  return useMutation<GOrganisation[]>({
    mutationFn: GlobalCatalogueService.FetchGOrganisationData,
    mutationKey: ['gOrganisation'],
    onSuccess: (data) => {
      const activeOrg = data?.find((org) => org.isActive);
      if (activeOrg) {
        dispatch(setActiveGOrganisation(activeOrg.orgId));
      } else {
        toast.error(
          GC_ORG_BACKEND_ERROR_MESSAGE
        );
      }
    },
    onError: () => {
      toast.error(GC_ORG_FETCH_ERROR_MESSAGE);
    },
  });
};
